import React from "react";

const Emoticons = ({ label, symbol, onClick }) => (
  <span
    role="img"
    aria-label={label ? label : ""}
    aria-hidden={label ? "false" : "true"}
    style={{ fontSize: "5rem", lineHeight: 1 }}
    onClick={onClick}
  >
    {symbol}
  </span>
);

export default Emoticons;
